import axios from 'axios'

axios.defaults.withCredentials = true;

import URLAPI from "@/libsV2/urlApi.js"
import qs from 'qs';
import {Toast} from 'mint-ui';
import store from './store/store.js'//引入store

var URL = "", URL5 = "", URL6 = "", APPID = "", envVersion = "";

URL = URLAPI.URL
URL5 = URLAPI.URL5
URL6 = URLAPI.URL6
APPID = URLAPI.APPID
envVersion = URLAPI.envVersion


const obj = {
    // 地址
    URL: URL,
    URL5: URL5,
    APPID: APPID,
    envVersion: envVersion,
    // shareURL                : shareURL,
    // AIP地址

    provinceList: "/District/index/provinceList/",

    hotCaseUrl: "/Xcx/Topic/getTopicRecommendList",
    caseListUrl: "/Xcx/Topic/getTopicList",
    caseSearchUrl: "/Xcx/Topic/searchTopicByKey",
    topicDetailsUrl: "/Xcx/Topic/getTopicDetails",
    shareUrl: "/Xcx/Topic/getShareConfig", //分享接口
    searchTopicListv2: "/Xcx/Topic/searchTopicListv2", //案例

    /*pumpDetail              : '/Pump/Index/detail',
      pumpQuestion            : '/Pump/Index/question',
      pumpModel               : '/Pump/Index/model',
      pumpAnswer              : '/Pump/Index/answer',
      pumpReport              : '/Pump/Index/report',
      pumpChosen              : '/Pump/Index/chosen',
      getReportDetail         : '/Pump/Index/getReportDetail',*/

    // 口碑地图好评列表
    TOPIC_COMMENT_TOPICS: "/topic/comment/topics",
    // 口碑地图好评列表Aes
    TOPIC_COMMENT_TOPICS_AES: "/topic/aes/topics",

    knowLedgrListUrl: "/CmsArticle/Index/getKnowledgeList", // 知识
    knowDetailUrl: "/CmsArticle/Index/getDetails", //知识详情
    recommendVideoUrl: "/CmsArticle/Index/getRecommendVideo",

    getCityId: "/District/Index/getCityInfoByName", //城市名称转id

    /*getWaterQuestion        : '/Water/Index/getWaterQuestion',
      submitReport            : '/Water/Index/submitWaterReport', // 提交报告
      getReportDetail         : '/Water/Index/getWaterReportDetail',// 报告详情
      getWaterList            : '/Water/Index/getWaterClassList',
      getWaterGoodsDetail     : '/Water/Index/getWaterGoodsDetail',// 产品详情
      getWaterCompase         : '/Water/Index/getWaterCompase',// 组合产品*/

    // 获得省市列表
    getProvinceList: "/District/Index/provinceList",
    getFoorplanCity: "comm/district/gettreeV2",

    appointUrl: "/Appoint/Index/submit", //预约
    appointThin: "/appoint/reservation/addappoint", //提交预约

    getTopicList: "/V3/Topic/searchTopicList", //案例列表搜索
    getdetails: "/V3/Topic/getDraftDetails", //案例详情（草稿）
    getopdetails: "/V3/topic/getTopicDetails", //案例详情（审核后）
    editDraft: "/v3/topic/editDraft", //编辑草稿
    publishDraft: "/v3/topic/publishTopic", //提交草稿

    getdraft: "/topic/index/draft", //草稿详情tp5版本
    gettopic: "topic/index/topic", //案例详情tp5版本
    //案例详情tp5加密版本
    TOPIC_AES_TOPIC: "topic/aes/topic",
    TOPIC_AES_DETAIL: "topic/aes/detail",
    TOPIC_AES_CODE: 'topic/index/createWxQrCode',

    // 案例地图
    getPlots: "/topic/index/plots", // 附近小区
    getCaseList: "/topic/index/topicByplots", // 小区案例列表
    // 小区案例列表Aes
    TOPIC_AES_TOPIC_BY_PLOTS: "/topic/aes/topicByplots",
    savePoster: "/topic/index/poster", //上传文件
    getcheck: "/topic/index/checkDraftTopic", //不通过审核

    topicGetConf: "/topic/index/getConf",
    // 获取配置AES
    TOPIC_AES_GET_CONF: "/topic/aes/getConf",
    topicModeScence: "/topic/index/modeScence",
    topicModeVideo: "/topic/index/modeVideo",
    topicCollect: "/topic/index/collect",
    // 获取案例详情Aes
    TOPIC_AES_COLLECT: "/topic/aes/collect",
    topicList: "/topic/index/lists",
    topicSearchplots: "/topic/index/searchplots",
    // 点击量采集
    BROWSE_STATISTICS: "analysis/aes/push",
    //口碑地图周边门店列表
    GETNEARLIST: "store/aes/lists",
    // topicSearchplots        :'/topic/index/searchplotsV3',
    // topicSearchplots        :'/topic/index/searchplotsV2',
    // topicSearchplots        :'/topic/index/searchplotsV4',
    topicSearchplotsV5: "/topic/index/searchplotsV5",
    TOPIC_AES_SEARCH_PLOTS_V5_AES: "/topic/aes/searchplotsV5",

    topicSearchplotsV6: "topic/index/searchplotsV6",
    TOOL_TRANSITION_INDEX: "tool/Transition/index", //获取城市id
    //获取城市idAes
    TOOL_AES_INDEX: "tool/aes/index",
    getcard: "/tool/card/index", //名片
    getCards: "/tool/ajn/cards", //名片
    toolCouponlist: "/tool/ajn/couponlist", //优惠券列表
    toolCouponget: "/tool/ajn/couponget", //领取券

    getUser: "/user/index/index", //用户信息 post5
    getUserTotal: "/User/Index/index", //总管用户信息 post

    // https://aotest.iwxapi.com/Api/V3/Topic/checkDraftTopic
    //通过审核
    // 2020
    flowReportinfo: "/flow/index/reportinfo", //报告详情
    getlists: "/shop/categorys/lists", //商品分类列表
    shopVr: "/shop/vr/index", //全景
    recommendList: "/recommend/index/lists", //科普

    uploadFile: "/comm/upload/index", //上传文件
    getOssSts: "/comm/upload/sts", //获取oss配置
    getOssSts2: "/comm/upload/sts2", //获取加密oss配置
    getcollect: "/comm/collect/collect",

    //艾暖通
    getUserlist: "/wind/index/userlist", //业主信息列表
    getUseradd: "/wind/index/useradd", //业主信息添加
    //案例报表
    praiseIndex: "/praise/index/index",
    praiseRank: "/praise/index/rank",
    praiseRankV2: "praise/indexv/rank",
    praiseFilterIng: "/praise/index/filtering",
    praiseFilterIngV2: "praise/indexv/filtering",
    praiseRankMinute: "/praise/index/rankminute",
    praiseRankMinuteV2: "praise/indexv/rankminute",
    praiseIndexBroken: "/praise/index/broken",
    praiseIndexViews: "/praise/index/views",
    praiseGoods: "/praise/index/goods",

    praiseIndexV2: "praise/indexv/index",
    praiseGoodsV2: "praise/indexv/goods",
    //CMS
    cmsLists: "/cms/index/lists",
    cmsChannels: "/cms/index/channels",
    cmsViews: "/cms/index/views",
    cmsDetail: "/cms/index/detail", //文章详情
    cmsPdfPath: "/cms/index/getPdfPath", //根据id获取pdf链接

    // 请求方法
    post(url, data = {}) {
        let that = this;
        let obj = Object.assign({}, data, {channel: 1});
        return new Promise((reslove, reject) => {
            // post请求
            axios
                .post(URL + url, qs.stringify(obj))
                .then((res) => {
                    if (res.data.error == 0) {
                        //异步操作完成 返回结果
                        reslove(res);
                    } else {
                        Toast({
                            message: res.data.msg,
                            duration: 500,
                        });
                    }
                })
                .catch((error) => {
                    Toast({
                        message: url + "错误",
                        position: "bottom",
                        duration: 1200,
                    });
                });
        });
    },

    post5(url, data = {}) {
        let obj = Object.assign({}, data, {channel: 1, source: "xcx"});
        return new Promise((reslove, reject) => {
            // post请求
            axios
                .post(URL5 + url, qs.stringify(obj))
                .then((res) => {
                    if (res.data.error == 0) {
                        //异步操作完成 返回结果
                        reslove(res);
                    } else {
                        Toast({
                            message: res.data.msg,
                            duration: 500,
                        });
                        store.commit("loadSwitch", false);
                        // reject();
                    }
                })
                .catch((error) => {
                    Toast({
                        message: url + "错误",
                        position: "bottom",
                        duration: 1200,
                    });
                });
        });
    },

    post6(url, data = {}) {
        let obj = Object.assign({}, data, {source: "xcx"});
        return new Promise((reslove, reject) => {
            // post请求
            axios
                .post(URL6 + url, qs.stringify(obj))
                .then((res) => {
                    if (res.data.error == 0) {
                        //异步操作完成 返回结果
                        reslove(res);
                    } else {
                        Toast({
                            message: res.data.msg,
                            duration: 500,
                        });
                        store.commit("loadSwitch", false);
                        // reject();
                    }
                })
                .catch((error) => {
                    Toast({
                        message: url + "错误",
                        position: "bottom",
                        duration: 1200,
                    });
                });
        });
    },
};

export default obj;
